var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMusicOff = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    fill: "none",
    viewBox: "0 0 58 58",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M32.974 38.032a4.624 4.624 0 0 1 4.625-4.624h.716c.252.135.483 0 .735-.116.251-.252.251-.484.251-.716V22.263c0-.368 0-.6-.251-.735-.116-.116-.484-.232-.735-.232l-12.983-1.954a.834.834 0 0 0-.851.851l-.136 20.006v.136c0 2.302-2.051 4.489-4.605 4.489S15 42.638 15 40.083s2.186-4.605 4.74-4.605h.6c.387 0 .619 0 .851-.252.135-.116.251-.367.251-.6V14l20.877 1.47v22.793c-.116 2.438-2.186 4.373-4.721 4.373-2.554.001-4.624-2.069-4.624-4.604",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "m7 47 45-35"
  })));
};
export default SvgMusicOff;